import Icon from '@vfz/ui/dist/components/icon/icon';
import React from 'react';
import { ContentUtil } from 'utils/content';

import { content } from './payment-pending.content';
import * as S from './payment-pending.styles';

const contentUtil = new ContentUtil({ content, componentName: 'PaymentPending' });

export const PaymentPending = () => {
  return (
    <S.PageWrapper data-testid="payment-pending">
      <S.Title>
        <h1>{contentUtil.translate('title')}</h1>
      </S.Title>
      <S.Content>{contentUtil.translateHtml('content')}</S.Content>
      <S.Link to="/facturen">
        <Icon name="arrowLeft" variant="solid" width={24} height={24} />
        {contentUtil.translate('linkText')}
      </S.Link>
    </S.PageWrapper>
  );
};
